import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { Table } from 'antd';
import firebase from 'firebase';
import mixpanel from 'mixpanel-browser';
import escapeRegexp from 'escape-string-regexp';
import { listenToInfographics } from 'modules/infographics';
import { TitleCell, ActionCell } from 'components/ListTableCells';
import ListFilter from 'components/ListFilter';

const filterFunctions = {
  all: () => true,
  mine: (obj, uid) => uid === obj.creator.uid,
  favorites: (obj, uid, favorites) => !!favorites[obj.key],
};

class InfographicListContainer extends React.Component {
  static propTypes = {};

  state = {
    filter: 'all',
    searchText: '',
  };

  async componentDidMount() {
    const { syncer, dListenToInfographics } = this.props;
    if (!syncer) {
      dListenToInfographics();
    }
  }

  onCreateInfographic = e => {
    e.preventDefault();
    mixpanel.track('Created infographic');
    this.props.dPush(`/infographics/new`);
  };

  onFavorite = key => {
    const { uid, favoriteInfographics } = this.props;
    const newValue = !favoriteInfographics[key];
    return firebase
      .database()
      .ref('users')
      .child(uid)
      .child('favoriteInfographics')
      .child(key)
      .set(newValue);
  };

  onSetPublic = async key => {
    const infographic = this.props.infographics.find(c => c.key === key);
    return firebase
      .database()
      .ref('infographics')
      .child(key)
      .child('isPublic')
      .set(!infographic.isPublic);
  };

  onDelete = key => {
    mixpanel.track('Deleted infographic', {
      id: key,
    });
    return firebase
      .database()
      .ref()
      .update({
        [`infographics/${key}`]: null,
        [`users/${this.props.uid}/infographics/${key}`]: null,
        [`users/${this.props.uid}/favoriteInfographics/${key}`]: null,
      });
  };

  onCopy = async key => {
    mixpanel.track('Copied infographic');
    const oldRef = firebase
      .database()
      .ref('infographics')
      .child(key);
    const newRef = firebase
      .database()
      .ref('infographics')
      .push();
    const oldSnap = await oldRef.once('value');
    const oldInfographic = oldSnap.val();
    await newRef.set({
      ...oldInfographic,
      creator: {
        uid: this.props.uid,
        email: this.props.email,
      },
      createdAt: firebase.database.ServerValue.TIMESTAMP,
      updatedAt: firebase.database.ServerValue.TIMESTAMP,
    });
    await firebase
      .database()
      .ref('users')
      .child(this.props.uid)
      .child('infographics')
      .child(newRef.key)
      .set(true);
    this.props.dPush(`/infographics/${newRef.key}`);
  };

  render() {
    const { infographics, uid, favoriteInfographics } = this.props;
    const { filter, searchText } = this.state;
    const searchRegexes = searchText
      .split(' ')
      .map(s => new RegExp(escapeRegexp(s), 'gi'));
    const dataSource = infographics
      .filter(c => filterFunctions[filter](c, uid, favoriteInfographics))
      .filter(chart =>
        searchRegexes.reduce((p, c) => p && chart.title.match(c), true)
      );
    const columns = [
      {
        title: 'TITLE',
        dataIndex: 'title',
        render: (title, { key }) => (
          <TitleCell title={title} route={`/infographics/${key}`} />
        ),
        sorter: (a, b) => a.title.localeCompare(b.title),
      },
      {
        title: 'CREATOR',
        key: 'creator',
        dataIndex: 'creator.email',
        sorter: (a, b) => a.creator.email.localeCompare(b.creator.email),
      },
      {
        title: 'ACTIONS',
        render: (title, row) => (
          <ActionCell
            id={row.key}
            onCopy={this.onCopy}
            onDelete={this.onDelete}
            uid={uid}
            creatorUid={row.creator.uid}
            favorite={!!favoriteInfographics[row.key]}
            onFavorite={this.onFavorite}
            isPublic={row.isPublic || false}
            onSetPublic={this.onSetPublic}
          />
        ),
      },
    ];
    return (
      <div>
        <h1>INFOGRAPHICS</h1>
        <ListFilter
          filter={filter}
          onChange={f =>
            this.setState({
              filter: f,
            })
          }
          searchText={searchText}
          onChangeSearch={t => {
            this.setState({ searchText: t });
          }}
          onCreate={this.onCreateInfographic}
          createText={'CREATE NEW INFOGRAPHIC'}
        />
        <div
          style={{
            background: 'white',
            marginLeft: '-16px',
            marginRight: '-16px',
            marginTop: '25px',
          }}
        >
          <Table
            pagination={false}
            rowClassName={(_, index) => {
              if (index % 2 === 1) {
                return 'table-odd';
              }
              return null;
            }}
            columns={columns}
            dataSource={dataSource}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  uid: state.auth.uid,
  email: state.auth.email,
  favoriteInfographics: state.auth.favoriteInfographics,
  infographics: state.infographics.infographics,
  syncer: state.infographics.syncer,
});

const mapDispatchToProps = dispatch => ({
  dPush: route => dispatch(push(route)),
  dListenToInfographics: () => dispatch(listenToInfographics()),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  InfographicListContainer
);



// WEBPACK FOOTER //
// ./src/containers/InfographicListContainer.js